// extracted by mini-css-extract-plugin
export default {"wrapper":"ProductForm_wrapper__-GXkj","container":"ProductForm_container__O1rWn","action":"ProductForm_action__inbJ6"};